import { Caret } from './Icons';

const PAGES = [
  ['home', 'home'],
  ['gallery', 'memories'],
  ['bio', 'me'],
  ['contact', 'call me'],
];

// `children` (the album notification) hangs just below the nav, so it never covers the links.
export default function Nav({ page, children }) {
  return (
    <nav className="sticky top-0 z-30 bg-black text-bone">
      <div className="flex items-center justify-center px-5 py-4 sm:justify-end md:px-10 md:py-5">
        <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 font-times text-base md:gap-x-8 md:text-lg">
          {PAGES.map(([id, label]) => (
            <li key={id}>
              <a
                href={id === 'home' ? '#/' : `#/${id}`}
                aria-current={page === id ? 'page' : undefined}
                className={`relative transition-colors ${
                  page === id ? 'text-mustard' : 'text-bone/70 hover:text-bone'
                }`}
              >
                {page === id && (
                  <Caret className="absolute right-full top-1/2 mr-1.5 h-[0.55em] w-[0.55em] -translate-y-1/2" />
                )}
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      {children}
    </nav>
  );
}
